<div class="tab-content">
	<div class="px-5 py-4">
		<form #SaveChargerUtilizationSettings="ngForm" (ngSubmit)="saveSiteChargerUtilizationSettings()" [validate-form]="'charger_utilization_settings'">
			<div class="tab-pane fade show active" id="chargers_utilization">
				<div class="row mb-4">
					<label for="min_daily_charge_operating_minutes" class="col-4 font-weight-bold">{{'site_utilization_settings.min_daily_charger_operating_minutes' | translate}}</label>
					<div class="col-8 d-flex">
						<input class="form-control input-field"
							type="number"
							[step]="chargerStepValues.min_daily_charge_operating_minutes"
							min="0"
							name="min_daily_charge_operating_minutes"
							[(ngModel)]="chargerSettings.min_daily_charge_operating_minutes"
							(input)="validateInputs()"
						>
						<span class="input-group-addon"><span>{{"g.minutes" | translate}}</span></span>
					</div>
				</div>
				<div class="row mb-4">
					<label for="min_daily_charge_utilization" class="col-4 font-weight-bold">{{'site_utilization_settings.min_daily_charger_utilization' | translate}}</label>
					<div class="col-8 d-flex">
						<input class="form-control input-field" 
							type="number"
							[step]="chargerStepValues.min_daily_charge_utilization"
							min="0"
							max="100"
							name="min_daily_charge_utilization"
							[(ngModel)]="chargerSettings.min_daily_charge_utilization"
							(input)="validateInputs()"
						>
						<span class="input-group-addon"><span>{{"g.percentage_unit" | translate}}</span></span>
					</div>
				</div>
				<div class="row mb-4">
					<label for="min_daily_charge_ah_utilization" class="col-4 font-weight-bold">{{'site_utilization_settings.min_daily_charge_ah_utilization' | translate}}</label>
					<div class="col-8 d-flex">
						<input class="form-control input-field" 
							type="number"
							[step]="chargerStepValues.min_daily_charge_ah_utilization"
							min="0"
							max="100"
							name="min_daily_charge_ah_utilization"
							[(ngModel)]="chargerSettings.min_daily_charge_ah_utilization"
							(input)="validateInputs()"
						>
						<span class="input-group-addon"><span>{{"g.percentage_unit" | translate}}</span></span>
					</div>
				</div>
				<div class="row mb-4">
					<label for="min_daily_charge_kwh_utilization" class="col-4 font-weight-bold">{{'site_utilization_settings.min_daily_charge_kwh_utilization' | translate}}</label>
					<div class="col-8 d-flex">
						<input class="form-control input-field" 
							type="number"
							[step]="chargerStepValues.min_daily_charge_kwh_utilization"
							min="0"
							max="100"
							name="min_daily_charge_kwh_utilization"
							[(ngModel)]="chargerSettings.min_daily_charge_kwh_utilization"
							(input)="validateInputs()"
						>
						<span class="input-group-addon"><span>{{"g.percentage_unit" | translate}}</span></span>
					</div>
				</div>
				<div class="row mb-4">
					<label for="minimum_charger_daily_ahr_usage" class="col-4 font-weight-bold">{{'site_utilization_settings.minimum_charger_daily_ahr_usage' | translate}}</label>
					<div class="col-8 d-flex">
						<input class="form-control input-field" 
							type="number"
							[step]="chargerStepValues.minimum_charger_daily_ahr_usage"
							min="0"
							name="minimum_charger_daily_ahr_usage"
							[(ngModel)]="chargerSettings.minimum_charger_daily_ahr_usage"
							(input)="validateInputs()"
						>
						<span class="input-group-addon"><span>{{"g.ahr" | translate}}</span></span>
					</div>
				</div>
				<div class="row mb-4">
					<label for="minimum_charger_daily_kwh_usage" class="col-4 font-weight-bold">{{'site_utilization_settings.minimum_charger_daily_kwh_usage' | translate}}</label>
					<div class="col-8 d-flex">
						<input class="form-control input-field" 
							type="number"
							[step]="chargerStepValues.minimum_charger_daily_kwh_usage"
							min="0"
							name="minimum_charger_daily_kwh_usage"
							[(ngModel)]="chargerSettings.minimum_charger_daily_kwh_usage"
							(input)="validateInputs()"
						>
						<span class="input-group-addon"><span>{{"g.kWh" | translate}}</span></span>
					</div>
				</div>
				<div class="row mb-4">
					<label for="maximum_charger_daily_kw_demand" class="col-4 font-weight-bold">{{'site_utilization_settings.maximum_charger_daily_kw_demand' | translate}}</label>
					<div class="col-8 d-flex">
						<input class="form-control input-field" 
							type="number"
							[step]="chargerStepValues.maximum_charger_daily_kw_demand"
							min="0"
							name="maximum_charger_daily_kw_demand"
							[(ngModel)]="chargerSettings.maximum_charger_daily_kw_demand"
							(input)="validateInputs()"
						>
						<span class="input-group-addon"><span>{{"g.kw" | translate}}</span></span>
					</div>
				</div>
				<div class="row mb-4">
					<label for="max_disconnect_days" class="col-4 font-weight-bold">{{'site_utilization_settings.max_disconnect_days' | translate}}</label>
					<div class="col-8 d-flex">
						<input class="form-control input-field" 
							type="number"
							[step]="chargerStepValues.max_disconnect_days"
							min="0"
							name="max_disconnect_days"
							[(ngModel)]="chargerSettings.max_disconnect_days"
							(input)="validateInputs()"
						>
						<span class="input-group-addon"><span>{{"g.days" | translate}}</span></span>
					</div>
				</div>
				<!-- Disconnect Exception Reporting Configuration -->
				<div class="row mb-4">
					<label class="col-4 font-weight-bold">{{'site_utilization_settings.low_disconnect_range' | translate}}</label>
					<div class="col-8">
						<div class="d-flex align-items-center">
							<div class="range-group">
								<span class="range-label">Min:</span>
								<input class="form-control input-field range-input" 
									type="number"
									[step]="chargerStepValues.low_disconnect_range_min"
									min="1"
									name="low_disconnect_range_min"
									[(ngModel)]="chargerSettings.low_disconnect_range_min"
									(input)="validateInputs()"
								>
							</div>
							<div class="range-group">
								<span class="range-label">Max:</span>
								<input class="form-control input-field range-input" 
									type="number"
									[step]="chargerStepValues.low_disconnect_range_max"
									[min]="chargerSettings.low_disconnect_range_min + 1"
									name="low_disconnect_range_max"
									[(ngModel)]="chargerSettings.low_disconnect_range_max"
									(input)="validateInputs()"
								>
							</div>
							<span class="input-group-addon"><span>{{"g.days" | translate}}</span></span>
						</div>
					</div>
				</div>

				<div class="row mb-4">
					<label class="col-4 font-weight-bold">{{'site_utilization_settings.mid_disconnect_range' | translate}}</label>
					<div class="col-8">
						<div class="d-flex align-items-center">
							<div class="range-group">
								<span class="range-label">Min:</span>
								<input class="form-control input-field range-input" 
									type="number"
									[step]="chargerStepValues.mid_disconnect_range_min"
									[min]="chargerSettings.low_disconnect_range_max + 1"
									name="mid_disconnect_range_min"
									[(ngModel)]="chargerSettings.mid_disconnect_range_min"
									(input)="validateInputs()"
								>
							</div>
							<div class="range-group">
								<span class="range-label">Max:</span>
								<input class="form-control input-field range-input" 
									type="number"
									[step]="chargerStepValues.mid_disconnect_range_max"
									[min]="chargerSettings.mid_disconnect_range_min + 1"
									name="mid_disconnect_range_max"
									[(ngModel)]="chargerSettings.mid_disconnect_range_max"
									(input)="validateInputs()"
								>
							</div>
							<span class="input-group-addon"><span>{{"g.days" | translate}}</span></span>
						</div>
					</div>
				</div>

				<div class="row mb-4">
					<label for="high_disconnect_limit" class="col-4 font-weight-bold">{{'site_utilization_settings.high_disconnect_limit' | translate}}</label>
					<div class="col-8 d-flex">
						<input class="form-control input-field" 
							type="number"
							[step]="chargerStepValues.high_disconnect_limit"
							[min]="chargerSettings.mid_disconnect_range_max + 1"
							name="high_disconnect_limit"
							[(ngModel)]="chargerSettings.high_disconnect_limit"
							(input)="validateInputs()"

						>
						<span class="input-group-addon"><span>{{"g.days" | translate}}</span></span>
					</div>
				</div>

				<div class="row mb-4">
					<label for="geofence_distance" class="col-4 font-weight-bold">{{'site_utilization_settings.geofence_distance' | translate}}</label>
					<div class="col-8 d-flex">
						<input class="form-control input-field" 
							type="number"
							[step]="chargerStepValues.geofence_distance"
							min="0"
							name="geofence_distance"
							[(ngModel)]="chargerSettings.geofence_distance"
							(input)="validateInputs()"
						>
						<span class="input-group-addon"><span>{{"g.ft_unit" | translate}}</span></span>
					</div>
				</div>

				<div class="row mb-4">
					<label for="site_operating_work" class="col-4 font-weight-bold">{{'site_utilization_settings.site_operating_work' | translate}}</label>
					<div class="col-8 d-flex">
						<div class="form-check form-check-inline" *ngFor="let day of workingDays; let dayIndex = index;">
							<input type="checkbox" class="form-check-input input-field"
								[value]="day.id"
								[id]="'workingDay-' + dayIndex"
								[checked]="isChecked(day.id)"
								(change)="onCheckboxChange(day.id, $event.target.checked)"
								name="workingDays-{{dayIndex}}"
							>
							<label class="form-check-label" [for]="'workingDay-' + dayIndex">{{ day.label }}</label>
						</div>
					</div>
				</div>
			</div>
			<div class="row my-4 align-items-center">
				<div class="col-md-4">
				</div>
				<div class="col-md-8">
					<div class="row align-items-center">
						<div class="col-md-8">
							<button type="submit" [disabled]="disableButton" class="btn text-white main-blue-bg btn-lg col-5 mr-4">{{'g.save' | translate}}</button>
						</div>
					</div>
				</div>
			</div>
		</form>
	</div>
</div>